import React from "react";
import { Stack, Drawer, Divider, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close"; // Import Close icon

export default function CustomDrawer({
  isOpenDrawer,
  onCloseDrawer,
  componentToPassDown,
  pageTitle,
  drawerWidth,
}) {
  return (
    <>
      <Drawer
        className={`forms-drawer ${drawerWidth ? "custom-drawer-width" : ""}`}
        anchor="right"
        open={isOpenDrawer}
        onClose={onCloseDrawer}
        PaperProps={{
          sx: { border: "none", overflow: "hidden" },
        }}
      >
        <div className="custom-drawer-header">
          <h4 className="drawer-title">{pageTitle}</h4>
          <div onClick={onCloseDrawer} className="model-red-cross">
            <CloseIcon />
          </div>
        </div>
        <Divider className="sidebar-divider" />
        <div className="custom-drawer-content">{componentToPassDown}</div>
      </Drawer>
    </>
  );
}
